<template>
  <div class="menu-item"
       :class="{ active: currentab === titleID && showActive, 'mobile-hidden': isHiddenMobile }"
       @click="openmenuitem(titleID)">
    <span class="menu-item-icon">
      <img :src="imgUrl(icon)" :alt="title">
    </span>
    <div class="menu-item-title">
      {{ title === 'Remote' ? 'Remote access' : title }}
      <span class="menu-item-arrow">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 8H14M14 8L6.92857 1M14 8L6.92857 15" stroke="#9485EF" stroke-width="2"/>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
const images = require.context('../assets/img/menus/', false, /\.svg$/)
export default {
  name: 'Menu',
  props: ['titleID', 'title', 'text', 'icon', 'currentab', 'showActive', 'isHiddenMobile'],
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    openmenuitem (title) {
      document.body.classList.remove('overflow-hidden')
      this.$emit('openmenuitem', title);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.menu-item {
  position: relative;
  width: 100%;
  cursor: pointer;
  transition: padding .3s;
  background: #EFF0F7;
  overflow: hidden;
  margin: 0;
  padding: 28px 40px;
  border-radius: 0;
  border: 1px solid #DDDDDD;
  border-bottom: 0;

  &:last-child {
    border-bottom: 1px solid #DDDDDD;
  }

  @include responsive-below-height('850px'){
    padding: 25px 40px;
  }

  @include responsive-below-height('750px'){
    padding: 18px 40px;
  }

  @include responsive-below($lg){
    padding: 24px;
  }

  @include responsive-below($sm){
    background: #F5F7FB;
    border-radius: 20px;
    margin-bottom: 8px;
    border: 0;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
    }

    &:not(.active):before {
      right: 22px;
      top: calc(50% - 22px);
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #E0E1EF;
    }

    &:not(.active):after {
      top: calc(50% - 5px);
      right: 40px;
      width: 8px;
      height: 8px;
      border: 2px solid #7D6AED;
      transform: rotate(45deg);
      border-left: 0;
      border-bottom: 0;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  &:not(.transparent) {
    display: flex;
    align-items: center;
  }

  &.transparent {
    background: #F5F7FB;
    border: 0;

    @include responsive-below($xs){
      padding: 0;
    }
  }

  &-title {
    margin-bottom: 0;
    font-size: 18px;
  }

  &-icon {
    position: relative;
    width: 35px;
    right: 0;
    bottom: 0;
    margin-right: 20px;

    &:before {
      width: 30px;
      height: 30px;
      transform: none;
    }
  }

  &.active {
    background: white;

    .menu-item-arrow {
      display: flex;
    }
  }

  &-title {
    font-size: 18px;
    font-weight: 700;
    color: #27272C;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-text {
    max-width: 70%;
  }

  &-arrow {
    display: none;
  }

  &-icon {
    &:before {
      content: "";
      display: block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #FFD02A;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    img {
      max-width: 100%;
      width: 65px;
      position: relative;
    }
  }
}
</style>
